import { EMAIL_REGEX, STRONG_PASSWORD_REGEX } from "../constant/regex";

export const SeatValidationSchema = (json, isEditMode) => {

    
    const MyPromise = new Promise((resolve, reject) => {
        var errorJson = {};

      

        if (json?.seatName === undefined || json?.seatName === '') {

            Object.assign(errorJson, { seatName: "Seat name cannot be empty *" });
        }
        if (json?.seatFor === undefined || json?.seatFor === '') {

            Object.assign(errorJson, { seatFor: "Selection of field is required *" });
        }
        if (json?.status === undefined || json?.status === '') {

            Object.assign(errorJson, { status: "Selection of field is required *" });
        }

       

     

        resolve(errorJson);
    })
    return MyPromise;
}

